<template>
  <span>
    <filtro-rapido
      id="filtro-rapido-empresa"
      :filtros="filtrosRapidos"
      :filtro-atual="filtroAtual"
      style="left: 15px !important"
      @selecionado="aplicarFiltroRapido($event)"
    />
  </span>
</template>

<style lang="scss">
</style>

<script>

export default {
  components: {
    FiltroRapido: () => import('@pilar/components/visualizacao-base/components/filtro-rapido/FiltroRapido.vue'),
  },
  props: {
  },
  data() {
    return {
      filtroAtual: null,
      filtrosRapidos: [
        {
          id: 'Favoritas',
          colunas: ['Favorita'],
          label: 'Empresas favoritas',
          valor: true,
        },
        {
          id: 'SemCertificado',
          colunas: ['SemCertificado'],
          label: 'Sem certificado / procuração',
          valor: true,
        },
        {
          id: 'ProcuracaoVencida',
          colunas: ['ProcuracaoVencida'],
          label: 'Procuração vencida',
          valor: true,
        },
        {
          id: 'ProcuracaoVencida30Dias',
          colunas: ['ProcuracaoVencida30Dias'],
          label: 'Procuração vencendo em 30 dias',
          valor: true,
        },
        {
          id: 'SituacaoFiscalRegular',
          colunas: ['SituacaoFiscalSituacao'],
          label: 'Situação fiscal regulares',
          valor: '1',
        },
        {
          id: 'SituacaoFiscalIrregular',
          colunas: ['SituacaoFiscalSituacao'],
          label: 'Situação fiscal irregulares',
          valor: '2',
        },
        {
          id: 'DctfWebAtiva',
          colunas: ['DctfWebSituacao'],
          label: 'DCTFWeb ativa',
          valor: '2',
        },
        {
          id: 'DctfWebEmAndamento',
          colunas: ['DctfWebSituacao'],
          label: 'DCTFWeb em Andamento',
          valor: '1',
        },
        {
          id: 'DctfWebOutras',
          colunas: ['DctfWebSituacao'],
          label: 'DCTFWeb outras',
          valor: '3, 4, 5',
        },
        {
          id: 'CndRegular',
          colunas: ['CndSituacaoRegular'],
          label: 'CND regular',
          valor: '1, 2',
        },
        {
          id: 'CndIrregular',
          colunas: ['CndSituacaoIrregular'],
          label: 'CND irregular',
          valor: '3',
        },
        {
          id: 'CndMotivo',
          colunas: ['CndSituacaoMotivo'],
          label: 'CND motivo',
          valor: '4, 5, 6, 7',
        },
        {
          id: 'CaixaPostalNaoLidas',
          colunas: ['CaixaPostalNaoLidas'],
          label: 'Caixa postal não lidas',
          valor: false,
        },
        {
          id: 'CaixaPostalRelevanteNaoLido',
          colunas: ['CaixaPostalRelevanteNaoLido'],
          label: 'Caixa postal importante não Lidas',
          valor: true,
        },
      ],
    }
  },
  created() {
  },
  methods: {
    aplicarFiltroRapido(filtro) {
      this.$emit('filtro-selecionado', filtro)
    },
  },
}
</script>
